import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Organizer } from '../../models/organizer';
import { OrganizerService } from '../../providers/organizer.service';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-organizer',
  templateUrl: './organizer.component.html',
styleUrls:  ['./organizer.component.css']
})
export class OrganizerComponent extends SmsAbstractAppPage implements OnInit {

	organizer: Organizer = new Organizer({});

  constructor(private route: ActivatedRoute, private organizerService: OrganizerService) {
  	super();
  }

  ngOnInit() {
  	this.route.params.subscribe(params => {
          if(params['id']){
            this.organizerService.get(params['id']).then(organizer => {
            	this.organizer = organizer;
            }).catch(error => {
            	this.handleError(error);
            });
        }
    }, error => {
    	this.handleError(error);
    });
  }

}
